"use client";

import dynamic from "next/dynamic";

interface Props {
  latitude: number;
  longitude: number;
  title?: string;
}

const PropertyMapClient = dynamic(() => import("./PropertyMapClient"), {
  ssr: false,
  loading: () => (
    <div className="w-full h-full rounded-2xl bg-gray-100 dark:bg-gray-800 animate-pulse flex items-center justify-center min-h-75">
      <span className="text-sm text-gray-400">جاري تحميل الخريطة...</span>
    </div>
  ),
});

export default function PropertyMap({ latitude, longitude, title }: Props) {
  if (!latitude || !longitude) return null;

  return (
    <div className="w-full h-100 mt-5">
      <PropertyMapClient
        latitude={latitude}
        longitude={longitude}
        title={title}
      />
    </div>
  );
}
